import React, { useState } from 'react'
import { CalendarIcon } from 'lucide-react'

interface EndOfDayDatePromptProps {
  isOpen: boolean
  initialDate: string
  onConfirm: (date: string) => void
}

export function EndOfDayDatePrompt({ isOpen, initialDate, onConfirm }: EndOfDayDatePromptProps) {
  const [value, setValue] = useState(initialDate)

  if (!isOpen) return null

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-4">
      <div className="bg-white rounded-lg shadow-xl max-w-md w-full p-6">
        <div className="flex items-center gap-2 mb-4">
          <CalendarIcon className="w-5 h-5 text-blue-600" />
          <h2 className="text-lg font-semibold text-gray-900">Closing out which day?</h2>
        </div>
        <p className="text-sm text-gray-600 mb-4">
          Choose the calendar date you are closing out. You can change this later from the header.
        </p>
        <input
          type="date"
          value={value}
          onChange={(e) => setValue(e.target.value)}
          className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
        />
        <button
          type="button"
          onClick={() => value && onConfirm(value)}
          className="mt-4 w-full px-4 py-2 bg-blue-600 text-white rounded-lg hover:bg-blue-700 transition-colors"
        >
          Continue
        </button>
      </div>
    </div>
  )
}
